import { render } from "./Permission.vue?vue&type=template&id=c15b82a2&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"

import "./Permission.vue?vue&type=style&index=0&id=c15b82a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c15b82a2"

export default script